function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWowMondo = function SvgWowMondo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2.44c.14.31.14.31.19.75-.29.46-.29.46-.73.96l-.47.55-.49.55-.41.49q-.28.32-.57.64-.29.31-.6.62-.3.3-.62.59-.31.3-.64.58l-.54.47c-.64.42-1.1.52-1.87.55l-.38-.38c.03-.46.03-.46.19-.93.34-.3.34-.3.78-.54.87-.54 1.52-1.16 2.22-1.9l.45-.44c.66-.67 1.22-1.4 1.8-2.13.59-.68.85-.63 1.69-.43",
    style: {
      fill: "#fbb613"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.38 10.1h5.05c1.11 0 1.11 0 1.32.21q.01.66 0 1.32-1.55.02-3.09.03-.53 0-1.06.01-.75.01-1.51.01l-.47.01c-1.1 0-1.1 0-1.51-.33-.24-.3-.24-.3-.19-.7.29-.73.73-.56 1.46-.56",
    style: {
      fill: "#fdb511"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.5c.36.15.36.15.75.38.22.67.22 1.29.22 1.99v1.3q0 .68.01 1.35v1.27c0 .7-.02.99-.42 1.58-.48.05-.48.05-.94 0-.39-.39-.22-1.24-.22-1.79v-.49q-.01-.51-.01-1.02 0-.79-.01-1.57v-1l-.01-.47c0-.44 0-.44.07-1.15z",
    style: {
      fill: "#fbb616"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.05 14.04h.9l.48.01h2.55q1.26.01 2.52.01.11.66.19 1.32c-.39.38-1.18.21-1.71.21l-.46.01h-2.45q-.47.01-.94.01h-.45c-.72 0-1.07-.01-1.68-.42.2-1.12.2-1.12 1.05-1.15",
    style: {
      fill: "#fdb203"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 2.81h.94q.74 1.61 1.36 3.27l.15.41c.36.96.36.96.36 1.39l.56.18V9c-.42.21-.42.21-.93.38-.66-.24-.76-.39-1.13-1.03-.43-.93-.77-1.89-1.1-2.87l-.19-.53-.17-.51-.16-.45c-.08-.52.04-.74.31-1.18",
    style: {
      fill: "#fcb612"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.15 15.5c1.01.01 1.8.42 2.69.87l.48.23c1.36.67 1.36.67 1.8 1.21.05.59.05.59 0 1.13-.18.19-.18.19-.58.26-.64-.09-.96-.36-1.46-.74-1.07-.74-2.35-1.2-3.58-1.58-.19-.19-.19-.19-.21-.66.04-.73.11-.65.86-.72",
    style: {
      fill: "#fcb510"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.21 17c.35.25.35.25.47.58l.05.41c.22 1.23.82 2.49 1.71 3.39.03.48.03.48 0 .93-.19.19-.19.19-.6.28-.67-.12-.95-.43-1.36-.95-.86-1.32-1.53-2.6-1.42-4.2.28-.55.58-.62 1.15-.44",
    style: {
      fill: "#fbb512"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27 16.91c.36.15.36.15.54.53q.03.48.03.96v2.92c-.03.43-.03.43-.21.8q-.57.02-1.13 0c-.48-.47-.23-1.77-.23-2.41l-.02-.63v-1.17c.06-.47.06-.47.32-.82.31-.21.31-.21.7-.18",
    style: {
      fill: "#fbba24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.7 14.31.42.13c.16.41.16.41.19.93-.4.47-.4.47-.94.94l-.49.49-.44.45-.28.34c-.29.22-.29.22-.77.28-.45-.06-.45-.06-.83-.43.05-.75.51-1.17 1-1.7l.44-.49c1.02-1.02 1.02-1.02 1.7-.94",
    style: {
      fill: "#fbb612"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72 5.28c.88.34 1.41 1.27 1.9 2.03.16.48.19.81.19 1.31L5.06 9c-.97-.65-1.73-1.58-2.25-2.63.04-.51.04-.51.19-.93.37-.19.37-.19.72-.16",
    style: {
      fill: "#fcb613"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02 12.15h.45q.58 0 1.16.04l.37.37c-.07.49-.07.49-.19.94-.62.21-1.11.23-1.77.23l-.64.02c-.63-.07-.88-.2-1.34-.63.27-1.19.85-.97 1.96-.97",
    style: {
      fill: "#fcb514"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38 9.56c.43.12.43.12.92.33l.49.21.3.14q.15.07.31.15.15.07.3.15.15.07.3.15.01.47 0 .93c-.29.29-.56.24-.96.26-.84-.01-1.35-.21-1.99-.74-.24-.27-.24-.27-.35-.77.11-.43.11-.43.68-.81",
    style: {
      fill: "#fcb611"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.38 14.06h7.12l.19 1.31c-.39.39-1.18.22-1.71.22l-.46.01h-2.45q-.47.01-.94.01h-.45c-.72 0-1.07-.01-1.68-.42l.19-.75.18.75h6.94l-.19-.94h-6.75z",
    style: {
      fill: "#fcba25"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69 17.25h.75v4.69l-.75-.19z",
    style: {
      fill: "#feb200"
    }
  }));
};
export default SvgWowMondo;